import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import { BodyTextL } from "../Typography";

export const QrStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        gap: 3,
        alignItems: "start",
    }),
);

export const DownloadIcon = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        mr: 3,
        display: "inline-flex",
    }),
);

export const QrPreview = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        width: "fit-content",
    }),
);

export const QrLabel = styled(BodyTextL)(({ theme }) =>
    theme.unstable_sx({
        mt: 2,
        fontSize: "1.5rem",
    }),
);

export const HowToDialogBody = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        width: { md: "480px" },
        overflow: "auto",
    }),
);

export const HowToDialogInner = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        pt: 7,
        pb: 7,
        px: 4,
    }),
);

export const HowToCloseButton = styled(Button)(({ theme }) =>
    theme.unstable_sx({
        alignSelf: "flex-end",
    }),
);
